"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["bonusPoints"] = "bonusPoints";
  TranslationKey["buy"] = "buy";
  TranslationKey["choose"] = "choose";
  TranslationKey["favorites"] = "favorites";
  TranslationKey["goBack"] = "goBack";
  TranslationKey["lowestPrice"] = "lowestPrice";
  TranslationKey["productIsDiscontinued"] = "productIsDiscontinued";
  TranslationKey["productIsDiscontinuedDescription"] = "productIsDiscontinuedDescription";
  TranslationKey["productNotFound"] = "productNotFound";
  TranslationKey["productNotFoundDescription"] = "productNotFoundDescription";
  TranslationKey["replace"] = "replace";
  TranslationKey["replaceWith"] = "replaceWith";
  TranslationKey["reserve"] = "reserve";
  TranslationKey["subscribe"] = "subscribe";
  TranslationKey["viewMoreDetails"] = "viewMoreDetails";
  return TranslationKey;
}({});